<template>
  <div>
    <div class="header">
      <div class="title">{{ $t('dispatch.title') }}</div>
      <div class="search">
        <reservation-search></reservation-search>
      </div>
      <div class="filter">
        <reservation-filter :forRouting="false" addCustom="true"></reservation-filter>
      </div>
      <div :class="{'more-filter-trigger':true, 'active':showFilter}" @click="showCustomFilter">
        <div>
          <i class="fas fa-filter"></i> Filter
        </div>
      </div>
      <transition name="slide-up">
        <dispatch-more-filter v-show="showFilter" class="more-filter"
          @close="showFilter = false"></dispatch-more-filter>
      </transition>
      <div class="buttons">
        <a href="/#/dispatch" class="button small">
          <i class="fas fa-chevron-left"></i>
          <span>Back</span>
        </a>
        <a href="/#/dispatch/map" target="_blank" class="button success small">
          <i class="far fa-map"></i>
          <span>{{ $t('dispatch.openMap') }}</span>
        </a>
      </div>
    </div>
    <div class="reservation-panel">

      <reservations-table :isShort="false"></reservations-table>
    </div>
    <div class="driver-panel">
      <transition name="grown-in">
        <driver-service-filter v-show="showServiceFilter"></driver-service-filter>
      </transition>
      <available-drivers></available-drivers>
    </div>

    <dispatch-modal></dispatch-modal>
    <dispatch-notification></dispatch-notification>
    <dispatch-schedule></dispatch-schedule>
    <ready-to-go-modal></ready-to-go-modal>
    <notes-modal></notes-modal>
  </div>
</template>

<script>
import AvailableDrivers from './AvailableDrivers'
import DispatchModal from './DispatchModal'
import DispatchNotification from './DispatchNotification'
import DispatchSchedule from './DispatchSchedule'
import ReservationsTable from './ReservationsTable'
import ReservationFilter from '@/components/Partials/ReservationFilter'
import ReservationSearch from '@/components/Partials/ReservationSearch'
import DispatchMoreFilter from './MoreFilter'
import ReadyToGoModal from './ReadyToGoModal'
import NotesModal from './NotesModal'
import DriverServiceFilter from './DriverServiceFilter'

export default {
  name: 'dispatch-reservations',
  components: {
    AvailableDrivers, DispatchModal, DispatchNotification, DispatchSchedule,
    ReservationsTable, ReservationFilter, ReservationSearch, DispatchMoreFilter,
    ReadyToGoModal, NotesModal, DriverServiceFilter
  },
  data () {
    return { showFilter: false }
  },
  computed: {
    reservations () { return this.$store.state.dispatch.itemsToShow },
    selectedFilter () { return this.$store.state.reservation.selectedFilter },
    showServiceFilter () { return this.$store.state.dispatch.serviceFilter.show }
  },
  methods: {
    showCustomFilter () {
      if (this.showFilter) {
        this.showFilter = false
          return
      }
      this.showFilter = true
      this.$store.commit('reservation/setSelectedFilter', 'custom')
    }
  },
  mounted () {
    // window.open('/#/dispatch/map')
  },
  watch: {
    selectedFilter (value) { this.showFilter = value === 'custom' }
  }
}
</script>

<style lang="scss" scoped>
$driver-panel-width: 30%;
.reservation-panel{
  position: fixed;
  top: 50px;
  left: 0;
  height: calc(100% - 50px);
  width: calc(100% - #{$driver-panel-width});
  overflow: auto;
}

.header{
  position: fixed;
  top: 0;
  left: 0;
  width: calc(100% - #{$driver-panel-width});
  height: 50px;
  background-color: #f9f9f9;
  box-shadow: 0 2px 4px rgba(0,0,0,0.15);
  z-index: 4;

  & .title{
    display: inline-block;
    margin: 0;
    font-size: 22px;
    font-weight: 700;
    padding-left: 65px;
    color: #3F2975;
    height: 50px;
    line-height: 50px;
    padding-right: 15px;
  }

  & .search {
    display: inline-block;
    height: 50px;
    width: 300px;
    position: absolute;
    left: 200px;
    top: 0;
  }

  & .filter {
    display: inline-block;
    position: absolute;
    top: 0;
    left: 500px;
    width: 250px;
  }

  .more-filter-trigger{
    position: absolute;
    top: 0;
    left: 749px;
    border:1px solid rgba(0,0,0, .3);
    height: 50px;
    padding: 0 15px;
    line-height: 50px;
    border-top: none;
    border-bottom: none;
    background: #fff;
    color: #555;
    cursor: pointer;

    .fa-filter{
      margin-right: 3px;
      color: #999;
      transition: all .3s ease;
    }
    &:hover{
      color:#333;
      i{ color: #333; }
    }
    &.active{
      background: #eaf1f3;
      i{ color: #333; }
    }
  }

  .more-filter{ transform-origin: top center; }

  & .buttons{
    display: inline-block;
    position: absolute;
    top: 0;
    right: 15px;
    height: 36px;
    margin: 7px 0;
    font-weight: 700;
    text-transform: uppercase;
  }
}


.driver-panel{
  position: fixed;
  top: 0;
  right: 0;
  z-index: 5;
  width: $driver-panel-width;
  height: 100%;
  background-color: #eee;
  box-shadow: 0 -2px 4px rgba(0,0,0,0.35);
  overflow-y: auto;

  & .title {
    font-size: 18px;
    font-weight: 700;
    margin-bottom: 15px;
  }
}

.slide-up-enter-active, .slide-up-leave-active { transition: all .3s ease; }
.slide-up-enter, .slide-up-leave-to {
  transform: rotateX(-90deg);
  opacity: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/Dispatch/DispatchReservations.vue